<template>
  <VModal ref="dialog" disable-backdrop-click @close="$emit('close')">
    <template #default="modalProps">
      <div class="rounded shadow-xs w-full max-w-lg mx-auto">
        <div class="rounded shadow-lg bg-gray-100 overflow-hidden flex flex-col">
          <div class="px-4 sm:px-6 py-5 border-b flex-none">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Create and/or select a project</h1>
              </div>

              <div class="flex-none">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="modalProps.close"
                >
                  <span class="sr-only">Close</span>
                  <svg
                    class="inline-flex h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 bg-white overflow-auto flex">
            <div v-if="!currentComponent" class="p-12 mx-auto self-center">
              <div class="flex gap-4">
                <BaseButton primary @click="currentComponent = 'SelectProject'"
                  >Select from existing</BaseButton
                >
                <BaseButton secondary @click="currentComponent = 'CreateNewProject'"
                  >Create custom</BaseButton
                >
              </div>
            </div>
            <ProjectSelector
              v-else-if="currentComponent === 'SelectProject'"
              :account-id="accountId"
              :customer-account-id="customerAccountId"
              @select="handleSelect"
              @back="currentComponent = null"
            />
            <ProjectBuilder
              v-else-if="currentComponent === 'CreateNewProject'"
              :account-id="accountId"
              :customer-account-id="customerAccountId"
              :default-project-data="defaultProjectData"
              @select="handleSelect"
              @back="currentComponent = null"
            />
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import ProjectSelector from './ProjectSelector.vue';
import ProjectBuilder from './ProjectBuilder.vue';

export default {
  components: { ProjectSelector, ProjectBuilder },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    customerAccountId: {
      type: String,
      required: true,
    },
    defaultProjectData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentComponent: null,
    };
  },
  methods: {
    handleSelect(projectId) {
      this.$emit('select', projectId);
      this.$refs.dialog.close();
    },
  },
};
</script>
